import DatePicker from "@base/Inputs/DatePicker/DatePicker"

export default DatePicker;
